<fl-modal
  [actions]="modalActions"
  modalTitle="Are you sure you want to select this profile?"
>
  <ng-container *ngIf="data.profileHasUserButNotInvestor">
    <p>
      This investment profile does not yet have the investor <strong>{{data.investorDetails.name}} ({{data.investorDetails.email}})</strong> as a member. 
      Selecting this profile will automatically add the investor to the profile.
    </p>
  </ng-container>
  <p>
    The following members of the selected profile will have access to the investment.
  </p>
  <h2 class="modal-sub-heading">{{data.entity.legal_name}}</h2>
  <fl-team 
    [actionButtons]="false"
    [compact]="true"
    [enableMemberSelectRoles]="false"
    [members]="data.entity.investment_account?.entity?.entity_members"
    [title]="false"
    [unpadded]="true"
    entityType="investment account"
  />
</fl-modal>
